import LegalDoc from "@/components/legal/LegalDoc";

export default function Privacy() {
  return <LegalDoc kind="privacy" />;
}
